import {
  lang_default
} from "../chunk-AIBH5CPR.mjs";
import "../chunk-3XF77UUS.mjs";
import {
  calculation_default
} from "../chunk-2MXO3K32.mjs";
import "../chunk-I6N6IZPN.mjs";
import "../chunk-WXSOZZRZ.mjs";
import "../chunk-TBX2S6DG.mjs";
import "../chunk-EINJ42AI.mjs";
import "../chunk-D3GX5FQV.mjs";

// src/client/index.ts
var SEOContentAnalyzer = (param, locale = "en") => {
  const { t } = lang_default(locale);
  return calculation_default(
    param,
    new DOMParser().parseFromString(param.content.toLowerCase(), "text/html"),
    t
  );
};
var client_default = SEOContentAnalyzer;
export {
  client_default as default
};
